import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { EmployeeContext } from "../../contexts/EmployeeContext"
import useService from "../../hooks/useService"
import { getEmployees, getEmployeesCount, refreshEmployees } from "../../services/Customer"
import { EMPLOYEE_DETAIL_FIELDS, IEmployee } from "../../Models/Employee"
import { GridColDef } from "@mui/x-data-grid"
import Table from "../custom/Table"
import Title from "../custom/Title"
import { Button, TextField } from "@mui/material"


const EmployeeSetup = () => {
    const navigate = useNavigate()
    const { employees, resetEmployees } = useContext(EmployeeContext)
    const { execute } = useService()
    const [count, setCount] = useState(0)
    const [key, setKey] = useState('')
    const [paginationModel, setPaginationModel] = useState({
      page: 0,
      pageSize: 10
    })
    const [filters, setFilters] = useState({
      key: ''
    })

    useEffect(() => {
        resetEmployees();
        fetchEmployees();
        getCount();
    }, []);

    useEffect(() => {
        getCount();
    }, [filters]);

    useEffect(() => {
        fetchEmployees();
    }, [paginationModel, filters]);

    const getColumns = () => {
        return EMPLOYEE_DETAIL_FIELDS.map<GridColDef<IEmployee>>(column => {
            return column;
        })
    }

    const fetchEmployees = () => {
        execute(() => getEmployees({ ...filters, pageNumber: paginationModel.page, pageSize: paginationModel.pageSize }));
    }

    const getCount = async () => {
        const { data } = await execute(() => getEmployeesCount(filters))
        if (data) setCount(data.count)
    }

    const refreshEmployeesList = async () => {
        const { data, error } = await execute(() => refreshEmployees({}));
        if(data && data.success) {
            setPaginationModel({
                page: 0,
                pageSize: 10
            });

            setKey('');
            
            setFilters({
                key: ''
            });
        }
    }

    const filterRecords = () => {
        setFilters({ key });
    }

    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Employee Setup</Title>
            </div>
            <div style={{ padding: '20px 0px', display: 'flex', flexDirection: 'row' }}>
                <div style={{ flex: 1, marginRight: '5px' }}>
                    <TextField
                        label='Search by name, phone or employee code'
                        size='small'
                        fullWidth
                        value={key}
                        onChange={(event) => setKey(event.target.value)}
                    />
                </div>
                <div style={{ marginRight: '5px' }}>
                    <Button variant='contained' onClick={filterRecords}>Filter</Button>
                </div>
                <div>
                    <Button variant='contained' onClick={refreshEmployeesList}>Refresh</Button>
                </div>
            </div>
            <div style={{ overflow: 'hidden' }}>
                <Table
                    paginationModel={paginationModel}
                    onPaginationModelChange={(model) => setPaginationModel(model)}
                    pageSizeOptions={[]}
                    columns={getColumns()}
                    rows={employees}
                    getRowId={(row) => row.employeeCode}
                    hideFooter={false}
                    rowCount={count}
                    paginationMode='server'
                    disableColumnFilter
                />
            </div>
        </div>
    )
}

export default EmployeeSetup
